export default {
	'hide-zero-lines': 'إخفاء الأسطر الصفرية'
}